import { useEffect } from 'react';

export function usePageMeta(title, description) {
    useEffect(function() {
        var suffix = ' | NexusRig';
        document.title = title ? title + suffix : 'NexusRig - PC Webshop';

        var metaDesc = document.querySelector('meta[name="description"]');
        if (description) {
            if (!metaDesc) {
                metaDesc = document.createElement('meta');
                metaDesc.name = 'description';
                document.head.appendChild(metaDesc);
            }
            metaDesc.content = description;
        }

        return function() {
            document.title = 'NexusRig - PC Webshop';
        };
    }, [title, description]);
}
